import React, { useState } from 'react'

function hashStr(s) {
  let h = 0
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0
  return Math.abs(h)
}

/** Deterministic profile-photo-style avatar (free, no key) used when no SSO photo exists. */
export function profilePhoto(seed) {
  return `https://api.dicebear.com/9.x/adventurer/svg?seed=${encodeURIComponent(
    seed || 'rival',
  )}&backgroundColor=1e293b,0f172a,111827`
}

export function Avatar({ src, name, seed, size = 64, ring = '#22d3ee', className = '' }) {
  const [broken, setBroken] = useState(false)
  const label = (name || '?').trim()
  const initial = (label.charAt(0) || '?').toUpperCase()
  const hue = hashStr(String(seed ?? label ?? 'x')) % 360
  const showImg = Boolean(src) && !broken

  return (
    <div
      className={`relative rounded-full overflow-hidden shrink-0 bg-slate-900 ${className}`}
      style={{ width: size, height: size, boxShadow: `0 0 0 2px ${ring}, 0 0 22px ${ring}66` }}
    >
      <div
        className="absolute inset-0 flex items-center justify-center text-white font-black select-none"
        style={{
          fontSize: size * 0.42,
          background: `radial-gradient(circle at 32% 26%, hsl(${hue} 85% 60%), hsl(${(hue + 55) % 360} 70% 32%))`,
        }}
      >
        {initial}
      </div>
      {showImg ? (
        <img
          src={src}
          alt={label}
          onError={() => setBroken(true)}
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : null}
    </div>
  )
}
